// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".free-plan[data-v-184e1601]{border:1px solid #f2f2f2}.label-free[data-v-184e1601]{color:#8bbfd0;font-weight:400;font-size:1rem}@media(min-width:48rem){.label-free[data-v-184e1601]{font-size:1rem}}", ""]);
// Exports
module.exports = exports;
